import styled, { css, keyframes } from 'styled-components';
import { pulse, slideIn } from '~styles/animations';


const slideOut = keyframes`
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(100%);
  }
`;


export const PopupContainer = styled.div<{ isVisible: boolean }>`
  position: fixed;
  top: 5rem;
  right: 1.5rem;
  z-index: 9999;
  pointer-events: ${props => props.isVisible ? 'auto' : 'none'};

  @media (max-width: 768px) {
    right: 0.75rem;
    top: 4rem;
    left: 0.75rem;
  }

  ${props => props.isVisible ? css`
    animation: ${slideIn} 0.3s ease-out forwards;
  ` : css`
    animation: ${slideOut} 0.3s ease-in forwards;
  `}
`;

export const PopupContent = styled.div`
  position: relative;
  background: white;
  border-radius: 0.75rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15), 0 4px 10px rgba(0, 0, 0, 0.1);
  min-width: 20rem;
  max-width: 24rem;
  width: 100%;
  padding: 1.25rem;
  border: 1px solid #e2e8f0;
  animation: ${pulse} 2s ease-in-out infinite;

  @media (max-width: 768px) {
    min-width: auto;
    max-width: 100%;
  }

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background: linear-gradient(180deg, #667eea 0%, #764ba2 100%);
    border-radius: 0.75rem 0 0 0.75rem;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  background: transparent;
  border: none;
  font-size: 1.5rem;
  line-height: 1;
  color: #64748b;
  cursor: pointer;
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  transition: all 0.2s ease;

  &:hover {
    background: #f1f5f9;
    color: #1e293b;
  }
`;

export const PopupHeader = styled.div`
  display: flex;
  gap: 0.75rem;
  margin-bottom: 1rem;
`;

export const PopupIconWrapper = styled.div<{ category?: string }>`
  flex-shrink: 0;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => {
    const colors: Record<string, string> = {
      'Tarefas': '#fef3c7',
      'Atendimento': '#dbeafe',
      'Pedidos': '#d1fae5',
      'Clientes': '#ede9fe',
      'Oportunidades': '#fce7f3',
      'Suporte': '#e0e7ff',
    };
    return colors[props.category || ''] || '#f1f5f9';
  }};

  svg {
    width: 1.25rem;
    height: 1.25rem;
    color: ${props => {
      const colors: Record<string, string> = {
        'Tarefas': '#f59e0b',
        'Atendimento': '#3b82f6',
        'Pedidos': '#10b981',
        'Clientes': '#8b5cf6',
        'Oportunidades': '#ec4899',
        'Suporte': '#6366f1',
      };
      return colors[props.category || ''] || '#64748b';
    }};
  }
`;

export const PopupTitle = styled.h4`
  font-size: 0.9375rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 0.375rem 0;
  line-height: 1.4;
`;

export const PopupDescription = styled.p`
  font-size: 0.8125rem;
  color: #64748b;
  margin: 0 0 0.5rem 0;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const PopupMeta = styled.div`
  display: flex;
  gap: 0.75rem;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 0.5rem;
`;

export const ClientInfo = styled.span`
  font-size: 0.75rem;
  color: #475569;
  font-weight: 500;
`;

export const TimeInfo = styled.span`
  font-size: 0.75rem;
  color: #94a3b8;
`;

export const PopupActions = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e2e8f0;
`;

export const PopupButton = styled.button<{ variant: 'primary' | 'secondary' }>`
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  font-size: 0.8125rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;

  ${props => props.variant === 'primary' ? css`
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
    }

    &:active {
      transform: translateY(0);
    }
  ` : css`
    background: #f1f5f9;
    color: #475569;

    &:hover {
      background: #e2e8f0;
    }
  `}
`;

